module.exports = __webpack_public_path__ + "img/福州大学.1d39da18.png";